<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="tip-bar">
                <i class="el-icon-info"></i>
                <div class="tip-content">
                    <span>宿舍检查项为独立三级模板；三级项可关联值周三级项以同步德育分。分值与关联值周项不一致时将标红提示。</span>
                </div>
            </div>

            <div class="tbl-scroll-host cat-list-host">
                <div class="cat-list" v-loading="listLoading">
                    <div v-if="!listLoading && !(categories && categories.length)" class="cat-list__empty">
                        <i class="el-icon-folder-opened"></i>
                        <span>暂无检查类别，请点击上方「新增一级」</span>
                    </div>
                    <article
                        v-for="l1 in categories"
                        :key="l1.Id"
                        class="cat-group"
                        :class="{ 'is-open': isGroupOpen(l1.Id) }"
                    >
                        <div class="cat-group__head" @click="toggleGroup(l1.Id)">
                            <button class="cat-group__fold" type="button" tabindex="-1" :title="isGroupOpen(l1.Id) ? '收起' : '展开'">
                                <i :class="isGroupOpen(l1.Id) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </button>
                            <div class="cat-group__main">
                                <div class="cat-group__name">{{ l1.Name }}</div>
                                <div class="cat-group__meta">
                                    <span class="cat-tag cat-tag--blue"><i class="el-icon-school"></i> {{ resolveCampusLabel(l1) }}</span>
                                    <span class="cat-tag cat-tag--green"><i class="el-icon-medal"></i> {{ l1.InitialScore }} 分</span>
                                    <span class="cat-tag cat-tag--gray"><i class="el-icon-folder"></i> {{ (l1.Children && l1.Children.length) || 0 }} 个子类</span>
                                </div>
                            </div>
                            <div class="cat-group__ops" @click.stop>
                                <el-button type="text" size="mini" icon="el-icon-plus" class="cat-btn-add" @click="handleAddSub1(l1)">添加二级</el-button>
                                <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l1)">编辑</el-button>
                                <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l1)">删除</el-button>
                            </div>
                        </div>
                        <div v-show="isGroupOpen(l1.Id)" class="cat-group__body">
                            <div
                                v-for="l2 in (l1.Children || [])"
                                :key="l2.Id"
                                class="cat-child"
                            >
                                <div class="cat-child__main">
                                    <span class="cat-child__dot"></span>
                                    <span class="cat-child__name">{{ l2.Name }}</span>
                                    <span class="cat-child__count" :class="{ 'is-empty': !((l2.Items && l2.Items.length) || 0) }">
                                        <i class="el-icon-document-checked"></i>
                                        检查项 {{ (l2.Items && l2.Items.length) || 0 }}
                                    </span>
                                </div>
                                <div class="cat-child__ops">
                                    <el-button type="text" size="mini" icon="el-icon-document" class="cat-btn-subitem" @click="handleItems(l2)">检查项</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l2)">编辑</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l2)">删除</el-button>
                                </div>
                            </div>
                            <div v-if="!(l1.Children && l1.Children.length)" class="cat-child--empty">
                                <span>当前分类下暂无二级类型，</span>
                                <span class="empty-add-btn" @click="handleAddSub1(l1)"><i class="el-icon-plus"></i>立即添加二级</span>
                            </div>
                        </div>
                    </article>
                </div>
            </div>

            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <!-- 类别编辑 -->
            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="480px" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                    <el-form-item label="校区" v-if="editForm.Level === 2 && !editForm.Id && !level2FromParentRow" prop="CampusId">
                        <el-select v-model="editForm.CampusId" placeholder="请先选择校区" style="width: 100%"
                            @change="handleLevel2CampusChange">
                            <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name"
                                :value="normalizeCampusId(c.Id)" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="校区" v-if="editForm.Level === 2 && !editForm.Id && level2FromParentRow">
                        <el-input :value="resolveCampusLabel(editForm)" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="父级类别"
                        v-if="editForm.Level === 2 && editForm.DepartmentId && level2CampusSelected && !level2FromParentRow"
                        prop="ParentId">
                        <el-select v-model="editForm.ParentId" placeholder="请选择父级类别" style="width: 100%">
                            <el-option v-for="item in parentCategories" :key="item.Id" :label="item.Name"
                                :value="item.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="父级类别" v-if="editForm.Level === 2 && !editForm.Id && level2FromParentRow">
                        <el-input :value="level2ParentName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="校区" v-if="editForm.Level === 1" prop="CampusId">
                        <el-select v-model="editForm.CampusId" placeholder="请选择校区" style="width: 100%">
                            <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name"
                                :value="normalizeCampusId(c.Id)" />
                        </el-select>
                        <div v-if="editForm.Id" class="form-tip">修改校区将同步更新其下所有二级类别</div>
                    </el-form-item>
                    <el-form-item label="类别名称" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="初始分" v-if="editForm.Level === 1" prop="InitialScore">
                        <el-input-number v-model="editForm.InitialScore" :precision="2" :step="0.1" :min="0" :max="1000"
                            style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="排序号" prop="SortOrder">
                        <el-input-number v-model="editForm.SortOrder" :min="0" style="width: 100%"></el-input-number>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <!-- 三级检查项 -->
            <el-dialog  :title="(currentCategory && currentCategory.Name) ? (currentCategory.Name + ' - 检查项目') : '检查项目'"
                :visible.sync="itemsDialogVisible" width="70%" :close-on-click-modal="false">
                <div class="item-toolbar">
                    <el-button type="primary" icon="el-icon-plus" @click="handleAddItem">新增</el-button>
                </div>
                <el-table :data="items" v-loading="itemsLoading" style="width: 100%; margin-top: 12px;">
                    <el-table-column prop="Name" label="检查项" min-width="140" align="center" show-overflow-tooltip />
                    <el-table-column prop="ChangeType" label="类型" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.ChangeType === 'Addition' ? 'success' : 'danger'" size="small">
                                {{ scope.row.ChangeType === 'Addition' ? '加分' : '扣分' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ScoreValue" label="宿舍分值" width="110" align="center">
                        <template slot-scope="scope">
                            <span :class="['score-value', scope.row.ChangeType === 'Addition' ? 'score-add' : 'score-deduct']">
                                {{ scope.row.ChangeType === 'Addition' ? '+' : '-' }}{{ scope.row.ScoreValue }}分
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="关联值周项" min-width="180" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <template v-if="scope.row.DutyInspectItemId">
                                <span :class="{ 'score-mismatch': isScoreMismatch(scope.row) }">
                                    {{ formatDutyLink(scope.row) }}
                                </span>
                                <el-tooltip v-if="isScoreMismatch(scope.row)" content="宿舍分值与关联值周项分值不一致，同步时以值周项为准"
                                    placement="top">
                                    <i class="el-icon-warning score-mismatch-icon"></i>
                                </el-tooltip>
                            </template>
                            <el-tag v-else type="info" size="mini" effect="plain">不同步值周</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Enabled" label="启用" width="80" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.Enabled === false ? 'info' : 'success'" size="mini">
                                {{ scope.row.Enabled === false ? '停用' : '启用' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" type="warning" @click="handleEditItem(scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="handleDelItem(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
                    <el-pagination layout="total, prev, pager, next" :total="itemsTotal" :page-size="itemsPageSize"
                        :current-page="itemsPage" @current-change="handleItemsCurrentChange"
                        @size-change="handleItemsSizeChange"></el-pagination>
                </div>

                <el-dialog :title="itemDialogTitle" :visible.sync="itemFormVisible" width="520px" append-to-body
                    :close-on-click-modal="false">
                    <el-form :model="itemForm" label-width="110px" :rules="itemFormRules" ref="itemForm">
                        <el-form-item label="检查项" prop="Name">
                            <el-input v-model="itemForm.Name" maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="类型" prop="ChangeType">
                            <el-radio-group v-model="itemForm.ChangeType">
                                <el-radio label="Deduction">扣分</el-radio>
                                <el-radio label="Addition">加分</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="宿舍分值" prop="ScoreValue">
                            <div class="score-input-wrapper">
                                <span class="score-prefix">{{ itemForm.ChangeType === 'Addition' ? '+' : '-' }}</span>
                                <el-input-number v-model="itemForm.ScoreValue" :precision="2" :step="0.1" :min="0"
                                    :max="1000" controls-position="right" style="width: calc(100% - 20px)">
                                </el-input-number>
                            </div>
                        </el-form-item>
                        <el-form-item label="关联值周二级">
                            <el-select v-model="dutySecondCategoryId" clearable filterable placeholder="不关联则不同步值周"
                                style="width: 100%" @change="onDutySecondChange">
                                <el-option v-for="c in dutySecondOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="关联值周三级" v-if="dutySecondCategoryId">
                            <el-select v-model="itemForm.DutyInspectItemId" clearable filterable placeholder="请选择值周检查项"
                                style="width: 100%" @change="onDutyItemChange">
                                <el-option v-for="it in dutyItemOptions" :key="it.Id"
                                    :label="formatDutyItemOption(it)" :value="it.Id" />
                            </el-select>
                        </el-form-item>
                        <el-alert v-if="itemForm.DutyInspectItemId && isItemFormScoreMismatch"
                            title="宿舍分值与所选值周项分值不一致，同步写入值周时将使用值周项分值" type="warning" :closable="false"
                            show-icon style="margin-bottom: 12px;"></el-alert>
                        <el-form-item label="排序号">
                            <el-input-number v-model="itemForm.SortOrder" :min="0" style="width: 100%"></el-input-number>
                        </el-form-item>
                        <el-form-item label="启用">
                            <el-switch v-model="itemForm.Enabled"></el-switch>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="itemFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="itemSubmit" :loading="itemLoading">确 定</el-button>
                    </div>
                </el-dialog>
            </el-dialog>

            <!-- 批量导入：选文件 -->
            <el-dialog :visible.sync="dormImportDialogVisible" width="860px" custom-class="person-import-dialog"
                :close-on-click-modal="false" append-to-body @closed="onDormImportDialogClosed">
                <div slot="title" class="pi-dialog-title">
                    <span class="pi-dialog-title__icon"><i class="el-icon-s-check"></i></span>
                    <div>
                        <strong>批量导入宿舍检查项</strong>
                        <p>下载模板填写后上传，学校以顶部所选为准；每行须填写具体校区名称</p>
                    </div>
                </div>
                <div class="pi-body">
                    <div class="pi-steps">
                        <div class="pi-step"><span class="pi-step__no">1</span><div><strong>下载模板</strong><em>按列填写分类与检查项</em></div></div>
                        <i class="el-icon-arrow-right pi-step__arrow"></i>
                        <div class="pi-step"><span class="pi-step__no">2</span><div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div></div>
                        <i class="el-icon-arrow-right pi-step__arrow"></i>
                        <div class="pi-step"><span class="pi-step__no">3</span><div><strong>核对导入</strong><em>预览后再确认写入</em></div></div>
                    </div>
                    <button type="button" class="pi-template-card" @click="downloadDormImportTemplate">
                        <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
                        <span class="pi-template-card__meta">
                            <strong>宿舍检查批量导入模板.xlsx</strong>
                            <em>含一级/二级、校区（必填）、检查项、可选关联值周项</em>
                        </span>
                        <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
                    </button>
                    <el-upload :key="'dorm-upload-' + dormImportUploadKey" class="pi-upload" drag action="#"
                        :auto-upload="false" :limit="1" :show-file-list="false" accept=".xlsx,.xls"
                        :on-change="onDormImportFileChange" :on-remove="onDormImportFileRemove" :on-exceed="onDormImportExceed">
                        <div v-if="dormImportFileRaw" class="pi-upload__file">
                            <i class="el-icon-success pi-upload__ok"></i>
                            <div><strong>{{ dormImportFileRaw.name }}</strong><em>已选择，点击「解析并预览」</em></div>
                        </div>
                        <div v-else class="pi-upload__empty">
                            <i class="el-icon-upload2"></i><strong>点击选择或拖拽 Excel 到此处</strong><em>仅支持 .xlsx / .xls</em>
                        </div>
                    </el-upload>
                </div>
                <div slot="footer" class="pi-footer">
                    <el-button @click="dormImportDialogVisible = false">关闭</el-button>
                    <el-button type="primary" icon="el-icon-view" :disabled="!dormImportFileRaw"
                        :loading="dormImportParsing" @click="parseDormImportFile">解析并预览</el-button>
                </div>
            </el-dialog>

            <!-- 批量导入：预览确认 -->
            <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="82%"
                custom-class="person-import-dialog" append-to-body
                :before-close="(done) => { this.backToDormImportSelect(); done(); }">
                <div slot="title" class="pi-dialog-title">
                    <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
                    <div><strong>宿舍检查导入核对</strong><p>共 {{ outputs.length }} 条，确认无误后写入系统</p></div>
                </div>
                <el-table :data="pagedOutputs" class="pi-preview-table" border stripe style="width: 100%" max-height="520">
                    <el-table-column prop="CategoryLevel1" label="一级分类" min-width="110" show-overflow-tooltip />
                    <el-table-column prop="InitScore" label="初始分" width="80" show-overflow-tooltip />
                    <el-table-column prop="CampusName" label="校区" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="CategoryLevel2" label="二级分类" min-width="110" show-overflow-tooltip />
                    <el-table-column prop="ItemName" label="检查项目" min-width="120" show-overflow-tooltip />
                    <el-table-column prop="ItemType" label="类型" width="80" show-overflow-tooltip />
                    <el-table-column prop="ItemScore" label="分值" width="80" show-overflow-tooltip />
                    <el-table-column prop="DutyItemName" label="关联值周项" min-width="120" show-overflow-tooltip />
                    <el-table-column fixed="right" label="操作" align="center" width="90">
                        <template slot-scope="scope">
                            <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pi-preview-pager">
                    <el-pagination local-paging layout="total, prev, pager, next, jumper" :total="outputs.length"
                        :page-size="importPageSize" :current-page.sync="importPage"
                        @current-change="handleImportCurrentChange" @size-change="handleImportSizeChange" />
                </div>
                <div slot="footer" class="pi-footer">
                    <el-button @click="backToDormImportSelect">返回上一步</el-button>
                    <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">确认导入</el-button>
                </div>
            </el-dialog>

            <import-result-dialog :visible.sync="importResultVisible" :result="importResult" />
        </section>
    </section>
</template>

<script>
import {
    getDormInspectCategoryListPage,
    getDormInspectParentsByDepartment,
    addDormInspectCategory,
    editDormInspectCategory,
    deleteDormInspectCategory,
    getDormInspectItemListPage,
    addDormInspectItem,
    editDormInspectItem,
    deleteDormInspectItem,
    getDormDutyInspectItemOptions,
    importDormInspectItems,
} from '../../../api/modules/dormitory';
import { getCampusList } from '../../../api/modules/misc';
import { getButtonList } from '../../../promissionRouter';
import Toolbar from '../../../components/Toolbar';
import DepartmentPane from '../../../components/DepartmentPane';
import ImportResultDialog from '../../../components/ImportResultDialog';
import { normalizeImportBatchResponse } from '../../../utils/importResultParser';
import { read, utils, writeFile } from 'xlsx';
import '../../../style/person-import-dialog.css';
import {
    resolveActiveSchoolId,
    toDeptId,
    treeNodeDeptId,
    deptIdsEqual,
} from '../../../utils/deptCascaderProps';

export default {
    name: 'DormInspectItem',
    components: { Toolbar, DepartmentPane, ImportResultDialog },
    data() {
        return {
            filters: { campusId: null, name: '' },
            searchList: [
                { label: '名称', key: 'name' },
                {
                    label: '校区',
                    key: 'campusId',
                    type: 'select',
                    clearable: true,
                    init: false,
                    initValue: null,
                    options: [
                        { label: '全部校区', value: -1 },
                    ],
                },
            ],
            campusOptions: [],
            schoolDepartmentId: 0,
            categories: [],
            expandedGroups: {},
            parentCategories: [],
            total: 0,
            buttonList: [],
            page: 1,
            PageSize: 10,
            listLoading: false,
            DepartmentId: 0,
            dialogTitle: '',
            editFormVisible: false,
            editLoading: false,
            level2FromParentRow: false,
            level2ParentName: '',
            editFormRules: {
                Name: [{ required: true, message: '请输入类别名称', trigger: 'blur' }],
                InitialScore: [
                    { required: true, message: '请输入初始分', trigger: 'blur' },
                    { type: 'number', message: '请输入有效的数字', trigger: 'blur' },
                ],
                CampusId: [{
                    validator: (rule, value, callback) => {
                        // 从一级行点「添加子类」时校区只读展示，已绑定父级校区
                        if (this.editForm.Level === 2 && this.level2FromParentRow) {
                            return callback();
                        }
                        const cid = toDeptId(value);
                        if (!cid) {
                            callback(new Error('请选择具体校区'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'change',
                }],
                ParentId: [{ required: true, message: '请选择父级类别', trigger: 'change' }],
            },
            editForm: {
                Id: 0,
                Name: '',
                InitialScore: 100,
                DepartmentId: 0,
                DepartmentName: '',
                CampusId: null,
                ParentId: null,
                Level: 1,
                SortOrder: 0,
            },
            itemsDialogVisible: false,
            currentCategory: null,
            items: [],
            itemsLoading: false,
            itemsPage: 1,
            itemsPageSize: 8,
            itemsTotal: 0,
            itemFormVisible: false,
            itemLoading: false,
            itemDialogTitle: '新增检查项',
            itemFormRules: {
                Name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
                ChangeType: [{ required: true, message: '请选择类型', trigger: 'change' }],
                ScoreValue: [
                    { required: true, message: '请输入分值', trigger: 'blur' },
                    { type: 'number', message: '请输入有效的数字', trigger: 'blur' },
                ],
            },
            itemForm: {
                Id: 0,
                Name: '',
                CategoryId: 0,
                ChangeType: 'Deduction',
                ScoreValue: 0,
                DutyInspectItemId: null,
                SortOrder: 0,
                Enabled: true,
            },
            dutySecondOptions: [],
            dutyItemOptions: [],
            dutySecondCategoryId: null,
            selectedDutyItemMeta: null,
            // 导入
            outputs: [],
            excelShow: false,
            dormImportDialogVisible: false,
            dormImportFileRaw: null,
            dormImportParsing: false,
            dormImportUploadKey: 0,
            dormImportKeepFileOnClose: false,
            importPage: 1,
            importPageSize: 10,
            importResultVisible: false,
            importResult: null,
        };
    },
    computed: {
        level2CampusSelected() {
            if (this.editForm.Level !== 2) return false;
            return !!toDeptId(this.editForm.CampusId);
        },
        isItemFormScoreMismatch() {
            if (!this.itemForm.DutyInspectItemId || !this.selectedDutyItemMeta) return false;
            return this.compareScoreMismatch(this.itemForm, this.selectedDutyItemMeta);
        },
        pagedOutputs() {
            const start = (this.importPage - 1) * this.importPageSize;
            return (this.outputs || []).slice(start, start + this.importPageSize);
        },
    },
    methods: {
        isGroupOpen(id) {
            return !!(this.expandedGroups && this.expandedGroups[id]);
        },
        toggleGroup(id) {
            if (!this.expandedGroups) this.$set(this, 'expandedGroups', {});
            this.$set(this.expandedGroups, id, !this.expandedGroups[id]);
        },
        /** 校区 Id 统一为字符串。最后修改：2026-10-18 */
        normalizeCampusId(id) {
            return toDeptId(id);
        },
        resolveCampusLabel(row) {
            if (!row) return '—';
            if (row.CampusName) return row.CampusName;
            const cid = toDeptId(row.CampusId);
            if (!cid) return '—';
            const hit = (this.campusOptions || []).find(c => deptIdsEqual(c.Id, cid));
            return hit ? hit.Name : String(cid);
        },
        /** 新增时默认校区：筛选项若为具体校区则带入，否则空 */
        defaultCampusIdForForm() {
            const cid = this.filters.campusId;
            if (cid == null || cid === '' || Number(cid) < 0) return null;
            return toDeptId(cid) || null;
        },
        getCurrentSchoolId() {
            const schoolId = toDeptId(this.schoolDepartmentId) || toDeptId(this.DepartmentId) || resolveActiveSchoolId(this);
            return schoolId || '';
        },
        treeNodeClick(data) {
            const nodeId = treeNodeDeptId(data);
            if (!nodeId) return;
            this.DepartmentId = nodeId;
            const orgType = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase();
            if (orgType === 'school') {
                this.schoolDepartmentId = nodeId;
            } else {
                this.schoolDepartmentId = toDeptId(data.schoolId || data.SchoolId) || nodeId;
            }
            this.filters.campusId = null;
            this.loadCampusOptions();
            this.$nextTick(() => {
                if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                    this.$refs.toolbar.searchObj.campusId = null;
                }
                this.handleQuery();
            });
        },
        async loadCampusOptions() {
            if (!this.schoolDepartmentId) {
                this.campusOptions = [];
                this.syncCampusSearchOptions();
                return;
            }
            try {
                const res = await getCampusList({
                    departmentId: this.schoolDepartmentId,
                    page: 1,
                    intPageSize: 999,
                });
                this.campusOptions = (res && res.data && res.data.response && res.data.response.data) || [];
            } catch (e) {
                this.campusOptions = [];
            }
            this.syncCampusSearchOptions();
        },
        syncCampusSearchOptions() {
            const opts = [
                { label: '全部校区', value: -1 },
            ].concat((this.campusOptions || []).map(c => ({
                label: c.Name,
                value: toDeptId(c.Id),
            })));
            const idx = this.searchList.findIndex(s => s.key === 'campusId');
            if (idx >= 0) {
                this.$set(this.searchList, idx, { ...this.searchList[idx], options: opts });
            }
        },
        handleQuery(keepExpanded = true) {
            const schoolId = this.getCurrentSchoolId();
            if (!schoolId) {
                this.categories = [];
                this.total = 0;
                return;
            }
            const cid = this.filters.campusId;
            const campusId =
                cid == null || cid === '' || Number(cid) < 0 ? -1 : toDeptId(cid);
            this.listLoading = true;
            getDormInspectCategoryListPage({
                schoolId,
                departmentId: schoolId,
                campusId,
            }).then(res => {
                let tree = (res.data && res.data.response) || [];
                if (!Array.isArray(tree)) tree = [];
                // 名称筛选（一级命中或子类命中则保留）
                const name = (this.filters.name || '').trim();
                if (name) {
                    const match = (n) => (n.Name || '').indexOf(name) >= 0;
                    tree = tree.map(l1 => {
                        const children = (l1.Children || []).filter(l2 => match(l2) || match(l1));
                        if (match(l1) || children.length) {
                            return { ...l1, Children: match(l1) ? (l1.Children || []) : children };
                        }
                        return null;
                    }).filter(Boolean);
                }
                this.categories = tree;
                this.total = tree.length;
                if (name) {
                    const expanded = { ...(this.expandedGroups || {}) };
                    (tree || []).forEach(item => {
                        if (item && item.Id) expanded[item.Id] = true;
                    });
                    this.expandedGroups = expanded;
                } else if (keepExpanded) {
                    const nextExpanded = { ...(this.expandedGroups || {}) };
                    this.expandedGroups = nextExpanded;
                } else {
                    this.expandedGroups = {};
                }
            }).finally(() => {
                this.listLoading = false;
            });
        },
        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery(true);
        },
        handleSizeChange(val) {
            this.PageSize = val;
            this.handleQuery(true);
        },
        callFunction(item) {
            if (typeof item.search === 'object') {
                this.filters = { ...this.filters, ...item.search };
            } else {
                this.filters = { ...this.filters, name: item.search };
            }
            if (item.Func && typeof this[item.Func] === 'function') {
                this[item.Func](item);
            } else {
                this.page = 1;
                this.handleQuery();
            }
        },
        handleAdd() {
            const schoolId = this.getCurrentSchoolId();
            if (!schoolId) {
                this.$message.warning('请先在左侧选择具体的学校机构');
                return;
            }
            this.level2FromParentRow = false;
            this.dialogTitle = '新增一级类别';
            this.editFormVisible = true;
            this.editForm = {
                Id: 0,
                Name: '',
                InitialScore: 100,
                DepartmentId: schoolId,
                DepartmentName: '',
                CampusId: this.defaultCampusIdForForm(),
                ParentId: null,
                Level: 1,
                SortOrder: 0,
            };
        },
        handleAddSub() {
            const schoolId = this.getCurrentSchoolId();
            if (!schoolId) {
                this.$message.warning('请先在左侧选择具体的学校机构');
                return;
            }
            this.level2FromParentRow = false;
            this.level2ParentName = '';
            this.dialogTitle = '新增二级类别';
            this.editFormVisible = true;
            this.parentCategories = [];
            this.editForm = {
                Id: 0,
                Name: '',
                InitialScore: 0,
                DepartmentId: schoolId,
                DepartmentName: '',
                CampusId: this.defaultCampusIdForForm(),
                ParentId: null,
                Level: 2,
                SortOrder: 0,
            };
            if (this.editForm.CampusId) {
                this.loadParentCategories(schoolId, this.editForm.CampusId);
            }
        },
        handleAddSub1(row) {
            this.level2FromParentRow = true;
            this.level2ParentName = row.Name;
            this.dialogTitle = '新增二级类别';
            this.editFormVisible = true;
            this.editForm = {
                Id: 0,
                Name: '',
                InitialScore: 0,
                DepartmentId: row.DepartmentId || this.getCurrentSchoolId(),
                DepartmentName: row.DepartmentName || '',
                CampusId: this.normalizeCampusId(row.CampusId),
                ParentId: row.Id,
                Level: 2,
                SortOrder: 0,
            };
        },
        handleEdit(row) {
            this.level2FromParentRow = false;
            this.dialogTitle = row.Level === 1 ? '编辑一级类别' : '编辑二级类别';
            this.editFormVisible = true;
            // CampusId 与下拉 option 统一为字符串 Id。最后修改：2026-10-18
            const campusId = this.normalizeCampusId(row.CampusId);
            this.editForm = Object.assign({}, row, {
                CampusId: campusId || null,
            });
            if (!this.campusOptions.length && this.schoolDepartmentId) {
                this.loadCampusOptions();
            }
            if (row.Level === 2) {
                this.loadParentCategories(row.DepartmentId, campusId || row.CampusId);
            }
        },
        handleDel(row) {
            this.$confirm('确认删除该类目吗？其下检查项也将不可用。', '提示', { type: 'warning' }).then(() => {
                deleteDormInspectCategory({ id: row.Id }).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success('删除成功');
                        this.handleQuery();
                    } else {
                        this.$message.error((res.data && res.data.msg) || '删除失败');
                    }
                });
            }).catch(() => {});
        },
        handleLevel2CampusChange(val) {
            this.editForm.ParentId = null;
            this.loadParentCategories(this.editForm.DepartmentId, val);
        },
        loadParentCategories(departmentId, campusId) {
            getDormInspectParentsByDepartment({
                departmentId,
                campusId: campusId == null ? 0 : campusId,
            }).then(res => {
                this.parentCategories = (res.data && res.data.response) || [];
            });
        },
        editSubmit() {
            this.$refs.editForm.validate(valid => {
                if (!valid) return;
                this.editLoading = true;
                const schoolId = this.getCurrentSchoolId() || this.editForm.DepartmentId;
                const payload = {
                    ...this.editForm,
                    SchoolId: schoolId,
                    DepartmentId: schoolId,
                };
                const req = payload.Id ? editDormInspectCategory(payload) : addDormInspectCategory(payload);
                req.then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success('保存成功');
                        this.editFormVisible = false;

                        const targetParentId = payload.Level === 2 ? payload.ParentId : null;
                        const newId = payload.Id || (res.data.response && (res.data.response.Id || res.data.response));
                        if (targetParentId) {
                            this.$set(this.expandedGroups, targetParentId, true);
                        } else if (newId) {
                            this.$set(this.expandedGroups, newId, true);
                        }

                        this.handleQuery(true);
                    } else {
                        this.$message.error((res.data && res.data.msg) || '保存失败');
                    }
                }).finally(() => {
                    this.editLoading = false;
                });
            });
        },
        handleItems(row) {
            this.currentCategory = row;
            this.itemsDialogVisible = true;
            this.itemsPage = 1;
            this.loadItems();
        },
        loadItems(force = false) {
            if (!this.currentCategory) return;
            // 非强制时可用树上缓存；保存/删除后必须 force，否则关联值周名不更新。最后更新：2026-09-23
            if (!force && Array.isArray(this.currentCategory.Items)) {
                this.items = this.currentCategory.Items.slice();
                this.itemsTotal = this.items.length;
                return;
            }
            const schoolId = this.getCurrentSchoolId();
            this.itemsLoading = true;
            getDormInspectItemListPage({
                categoryId: this.currentCategory.Id,
                schoolId,
                departmentId: schoolId,
                campusId: this.currentCategory.CampusId,
            }).then(res => {
                const resp = (res.data && res.data.response) || {};
                this.items = resp.data || resp || [];
                if (!Array.isArray(this.items)) this.items = [];
                this.itemsTotal = resp.dataCount != null ? resp.dataCount : this.items.length;
                this.$set(this.currentCategory, 'Items', this.items.slice());
                this.syncCategoryItemsInTree(this.currentCategory.Id, this.items);
            }).finally(() => {
                this.itemsLoading = false;
            });
        },
        /** 把最新检查项写回类别树，避免下次仍读到旧关联值周。创建于 2026-09-23 */
        syncCategoryItemsInTree(categoryId, items) {
            const walk = (nodes) => {
                for (const n of nodes || []) {
                    if (String(n.Id) === String(categoryId)) {
                        this.$set(n, 'Items', (items || []).slice());
                        return true;
                    }
                    if (walk(n.Children)) return true;
                }
                return false;
            };
            walk(this.categories);
        },
        handleItemsCurrentChange(val) {
            this.itemsPage = val;
            this.loadItems();
        },
        handleItemsSizeChange(val) {
            this.itemsPageSize = val;
            this.loadItems();
        },
        async loadDutyOptions() {
            const schoolId = this.getCurrentSchoolId();
            if (!schoolId) return;
            try {
                const res = await getDormDutyInspectItemOptions({
                    schoolId,
                    departmentId: schoolId,
                    campusId: this.currentCategory ? this.currentCategory.CampusId : 0,
                });
                const list = (res.data && res.data.response) || [];
                // 支持后端返回二级树：[{ Id, Name, Items: [...] }] 或扁平项
                if (list.length && list[0].Items) {
                    this.dutySecondOptions = list.map(c => ({
                        Id: c.Id,
                        Name: c.Name || c.CategoryName,
                        Items: c.Items || [],
                    }));
                } else {
                    const map = {};
                    (list || []).forEach(it => {
                        const sid = it.CategoryId || it.SecondCategoryId || it.ParentId;
                        const sName = it.CategoryName || it.SecondCategoryName || '未分类';
                        if (!map[sid]) map[sid] = { Id: sid, Name: sName, Items: [] };
                        map[sid].Items.push(it);
                    });
                    this.dutySecondOptions = Object.values(map);
                }
            } catch (e) {
                this.dutySecondOptions = [];
            }
        },
        onDutySecondChange(val) {
            this.itemForm.DutyInspectItemId = null;
            this.selectedDutyItemMeta = null;
            const hit = (this.dutySecondOptions || []).find(c => String(c.Id) === String(val));
            this.dutyItemOptions = (hit && hit.Items) || [];
        },
        onDutyItemChange(val) {
            const hit = (this.dutyItemOptions || []).find(it => String(it.Id) === String(val));
            this.selectedDutyItemMeta = hit || null;
        },
        formatDutyItemOption(it) {
            if (!it) return '';
            const type = it.ChangeType === 'Addition' ? '+' : '-';
            return `${it.Name}（${type}${it.ScoreValue}）`;
        },
        formatDutyLink(row) {
            if (row.DutyInspectItemName) {
                const type = row.DutyChangeType === 'Addition' ? '+' : '-';
                const score = row.DutyScoreValue != null ? `${type}${row.DutyScoreValue}` : '';
                return score ? `${row.DutyInspectItemName}（${score}）` : row.DutyInspectItemName;
            }
            return `值周项#${row.DutyInspectItemId}`;
        },
        compareScoreMismatch(dormItem, dutyMeta) {
            if (!dutyMeta) return false;
            const dormScore = Number(dormItem.ScoreValue);
            const dutyScore = Number(dutyMeta.ScoreValue != null ? dutyMeta.ScoreValue : dutyMeta.DutyScoreValue);
            const dormType = dormItem.ChangeType;
            const dutyType = dutyMeta.ChangeType || dutyMeta.DutyChangeType;
            if (Number.isNaN(dormScore) || Number.isNaN(dutyScore)) return false;
            return dormScore !== dutyScore || (dutyType && dormType !== dutyType);
        },
        isScoreMismatch(row) {
            if (!row || !row.DutyInspectItemId) return false;
            if (row.ScoreMismatch === true) return true;
            if (row.DutyScoreValue == null && !row.DutyChangeType) return false;
            return this.compareScoreMismatch(row, {
                ScoreValue: row.DutyScoreValue,
                ChangeType: row.DutyChangeType,
            });
        },
        async handleAddItem() {
            this.itemDialogTitle = '新增检查项';
            this.itemFormVisible = true;
            this.dutySecondCategoryId = null;
            this.dutyItemOptions = [];
            this.selectedDutyItemMeta = null;
            this.itemForm = {
                Id: 0,
                Name: '',
                CategoryId: this.currentCategory.Id,
                ChangeType: 'Deduction',
                ScoreValue: 0,
                DutyInspectItemId: null,
                SortOrder: 0,
                Enabled: true,
            };
            await this.loadDutyOptions();
            this.$nextTick(() => {
                if (this.$refs.itemForm) this.$refs.itemForm.clearValidate();
            });
        },
        async handleEditItem(row) {
            this.itemDialogTitle = '编辑检查项';
            this.itemFormVisible = true;
            this.itemForm = {
                Id: row.Id,
                Name: row.Name,
                CategoryId: row.CategoryId || this.currentCategory.Id,
                ChangeType: row.ChangeType || 'Deduction',
                ScoreValue: row.ScoreValue,
                DutyInspectItemId: row.DutyInspectItemId || null,
                SortOrder: row.SortOrder || 0,
                Enabled: row.Enabled !== false,
            };
            await this.loadDutyOptions();
            // 回显二级→三级
            let secondId = row.DutyCategoryId || row.DutyInspectCategoryId || null;
            if (!secondId && row.DutyInspectItemId) {
                for (const c of this.dutySecondOptions) {
                    if ((c.Items || []).some(it => String(it.Id) === String(row.DutyInspectItemId))) {
                        secondId = c.Id;
                        break;
                    }
                }
            }
            this.dutySecondCategoryId = secondId;
            this.onDutySecondChange(secondId);
            this.itemForm.DutyInspectItemId = row.DutyInspectItemId || null;
            this.onDutyItemChange(this.itemForm.DutyInspectItemId);
            this.$nextTick(() => {
                if (this.$refs.itemForm) this.$refs.itemForm.clearValidate();
            });
        },
        handleDelItem(row) {
            this.$confirm('确认删除该检查项吗？', '提示', { type: 'warning' }).then(() => {
                deleteDormInspectItem({ id: row.Id }).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success('删除成功');
                        this.loadItems(true);
                    } else {
                        this.$message.error((res.data && res.data.msg) || '删除失败');
                    }
                });
            }).catch(() => {});
        },
        itemSubmit() {
            this.$refs.itemForm.validate(valid => {
                if (!valid) return;
                this.itemLoading = true;
                const payload = {
                    ...this.itemForm,
                    DutyInspectItemId: this.itemForm.DutyInspectItemId || null,
                };
                const req = payload.Id ? editDormInspectItem(payload) : addDormInspectItem(payload);
                req.then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success('保存成功');
                        this.itemFormVisible = false;
                        // 强制拉最新检查项（含关联值周名称），勿用树上旧 Items。最后更新：2026-09-23
                        this.loadItems(true);
                    } else {
                        this.$message.error((res.data && res.data.msg) || '保存失败');
                    }
                }).finally(() => {
                    this.itemLoading = false;
                });
            });
        },
        // —— 批量导入 ——
        ImportCensus() {
            this.resetDormImportDialog();
            this.dormImportDialogVisible = true;
        },
        resetDormImportDialog() {
            this.dormImportFileRaw = null;
            this.dormImportParsing = false;
            this.dormImportUploadKey += 1;
        },
        onDormImportDialogClosed() {
            if (this.dormImportKeepFileOnClose) {
                this.dormImportKeepFileOnClose = false;
                return;
            }
            this.resetDormImportDialog();
        },
        backToDormImportSelect() {
            this.excelShow = false;
            this.dormImportDialogVisible = true;
        },
        onDormImportFileChange(file) {
            this.dormImportFileRaw = file && file.raw ? file.raw : null;
        },
        onDormImportFileRemove() {
            this.dormImportFileRaw = null;
        },
        onDormImportExceed(files) {
            const nextFile = files && files[0];
            if (!nextFile) return;
            this.dormImportUploadKey += 1;
            this.$nextTick(() => { this.dormImportFileRaw = nextFile; });
        },
        downloadDormImportTemplate() {
            const headers = [
                '一级分类', '初始分', '校区', '二级分类', '检查项目', '加减分类型', '分值', '关联值周检查项',
            ];
            const sample = ['宿舍卫生', '100', '一柒校园', '内务整理', '被子折叠不规范', '扣分', '2', ''];
            const sheet = utils.aoa_to_sheet([headers, sample]);
            const book = utils.book_new();
            utils.book_append_sheet(book, sheet, '宿舍检查导入');
            writeFile(book, '宿舍检查批量导入模板.xlsx');
        },
        parseDormImportFile() {
            if (!this.dormImportFileRaw) {
                this.$message.warning('请先选择 Excel 文件');
                return;
            }
            const file = this.dormImportFileRaw;
            if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                this.$message.error('上传格式不正确，请上传 xls 或 xlsx 格式');
                return;
            }
            this.dormImportParsing = true;
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const workbook = read(ev.target.result, { type: 'binary' });
                    const ws = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
                    this.outputs = this.reSetKey(ws);
                    this.importPage = 1;
                    this.dormImportParsing = false;
                    this.dormImportKeepFileOnClose = true;
                    this.dormImportDialogVisible = false;
                    this.excelShow = true;
                } catch (e) {
                    this.dormImportParsing = false;
                    this.$message.error('文件读取失败');
                }
            };
            fileReader.onerror = () => {
                this.dormImportParsing = false;
                this.$message.error('文件读取失败');
            };
            fileReader.readAsBinaryString(file);
        },
        resolveActiveSchoolId() {
            const raw = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId');
            if (raw === null || raw === undefined || raw === '' || raw === '0') return null;
            return raw;
        },
        showImportResult(resData) {
            this.importResult = (resData && resData.response) || null;
            this.importResultVisible = true;
            const normalized = normalizeImportBatchResponse(resData || {});
            if (!normalized.items.length) {
                const text = normalized.summary || (resData && resData.msg) || '';
                if (text) this.$message.success(text);
            }
        },
        removeImport(e) {
            const name = e.row.ItemName || e.row.CategoryLevel1 || '该行';
            this.$confirm('确定要删除 ' + name + ' 的信息?').then(() => {
                const realIndex = (this.importPage - 1) * this.importPageSize + e['$index'];
                this.outputs.splice(realIndex, 1);
                if (this.importPage > 1 && this.pagedOutputs.length === 0) {
                    this.importPage = this.importPage - 1;
                }
            });
        },
        SavaImport() {
            const schoolDepartmentId = this.resolveActiveSchoolId() || this.getCurrentSchoolId();
            if (!schoolDepartmentId) {
                this.$message.warning('请先在顶部或左侧选择学校');
                return;
            }
            if (!this.outputs.length) {
                this.$message.warning('没有可导入的数据，请检查导入内容');
                return;
            }
            const loading = this.$loading({ lock: true, text: '导入中', background: 'rgba(0, 0, 0, 0.7)' });
            importDormInspectItems({ schoolDepartmentId: schoolDepartmentId, items: this.outputs })
                .then((res) => {
                    loading.close();
                    if (res.data && res.data.success) {
                        this.excelShow = false;
                        this.showImportResult(res.data);
                        this.handleQuery();
                    } else {
                        this.showImportResult(res.data || {});
                        if (!this.importResult) {
                            this.$message.error((res.data && res.data.msg) || '导入失败');
                        }
                    }
                })
                .catch(() => {
                    loading.close();
                    this.$message.error('导入失败');
                });
        },
        reSetKey(ws) {
            const temp = [];
            (ws || []).forEach((item) => {
                temp.push({
                    CategoryLevel1: item['一级分类'] || item['检查类型（一级）'] || item['CategoryLevel1'] || '',
                    InitScore: item['初始分'] || item['检查类型初始分'] || item['InitScore'] || '',
                    CampusName: item['校区'] || item['CampusName'] || '',
                    CategoryLevel2: item['二级分类'] || item['检查类型（二级）'] || item['CategoryLevel2'] || '',
                    ItemName: item['检查项目'] || item['检查项目（三级）'] || item['ItemName'] || '',
                    ItemType: item['加减分类型'] || item['项目类型'] || item['ItemType'] || '',
                    ItemScore: item['分值'] || item['项目分值'] || item['ItemScore'] || '',
                    DutyItemName: item['关联值周检查项'] || item['关联值周项'] || item['DutyItemName'] || '',
                });
            });
            return temp;
        },
        handleImportCurrentChange(page) {
            this.importPage = page;
        },
        handleImportSizeChange(size) {
            this.importPageSize = size;
            this.importPage = 1;
        },
    },
    mounted() {
        const routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        // 菜单未配按钮时提供默认入口
        if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
            this.buttonList.push({ name: '查询', Func: 'handleQuery', id: -10 });
        }
        if (!this.buttonList.some(b => b.Func === 'handleAdd')) {
            this.buttonList.push({ name: '新增一级', Func: 'handleAdd', id: -1 });
        }
        if (!this.buttonList.some(b => b.Func === 'handleAddSub')) {
            this.buttonList.push({ name: '新增二级', Func: 'handleAddSub', id: -2 });
        }
        if (!this.buttonList.some(b => b.Func === 'ImportCensus')) {
            this.buttonList.push({ name: '导入', Func: 'ImportCensus', id: -3 });
        }
    },
};
</script>

<style scoped>
.tip-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 4px 0 14px;
    padding: 9px 14px;
    background: linear-gradient(135deg, #f0f7ff 0%, #e0f2fe 100%);
    border: 1px solid #bae6fd;
    border-radius: 8px;
    color: #0369a1;
    font-size: 13px;
    line-height: 1.45;
    box-shadow: 0 1px 2px rgba(2, 132, 199, 0.04);
}
.tip-bar i {
    color: #0284c7;
    font-size: 15px;
    flex-shrink: 0;
}
::v-deep .toolbar-btn-row {
    display: flex !important;
    flex-wrap: wrap;
    gap: 8px !important;
    align-items: center;
}
::v-deep .toolbar-btn-row .el-form-item {
    margin-right: 0 !important;
    margin-bottom: 0 !important;
}
::v-deep .toolbar-btn-row .el-button {
    margin-left: 0 !important;
}
.muted-dash {
    color: #c0c4cc;
}
.score-add {
    color: #67c23a;
}
.score-deduct {
    color: #f56c6c;
}
.score-mismatch {
    color: #f56c6c;
    font-weight: 600;
}
.score-mismatch-icon {
    color: #f56c6c;
    margin-left: 4px;
}
.score-input-wrapper {
    display: flex;
    align-items: center;
}
.score-prefix {
    width: 16px;
    text-align: center;
    font-weight: 600;
}
.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 4px;
}
.item-toolbar {
    margin-bottom: 4px;
}
.pagination-container {
    margin-top: 12px;
    overflow: hidden;
}
</style>
